/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.mqtt = {};
    Blockly.Blocks.mqtt.style = 'mqtt_blocks';
    Blockly.Blocks.mqtt.mqtt_server = "mqtt.eclipseprojects.io";
    Blockly.Blocks.mqtt_init_esp8266 = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.mqtt.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/mqtt.svg", 40, 25)).appendField(Blockly.Msg.MQTT_INIT + " (Esp8266 WiFi)");
            this.appendDummyInput().appendField("Rx").appendField(new Blockly.FieldDropdown(profile["default"].rxtx), "RX").appendField("Tx").appendField(new Blockly.FieldDropdown(profile["default"].rxtx),
                "TX").appendField(Blockly.Msg.MQTT_BAUDRATE).appendField(new Blockly.FieldDropdown([
                ["2400", "2400"],
                ["4800", "4800"],
                ["9600", "9600"],
                ["19200", "19200"],
                ["38400", "38400"],
                ["57600", "57600"],
                ["115200", "115200"]
            ]), "BAUD");
            this.appendDummyInput().appendField("WiFi " + Blockly.Msg.MQTT_WIFI_NAME).appendField(new Blockly.FieldTextInput(""), "WIFINAME").appendField(Blockly.Msg.MQTT_WIFI_PASS).appendField(new Blockly.FieldTextInput(""), "WIFIPASS");
            this.appendDummyInput().appendField(Blockly.Msg.MQTT_BROKER).appendField(new Blockly.FieldTextInput(Blockly.Blocks.mqtt.mqtt_server),
                "BROKER");
            this.appendDummyInput().appendField(Blockly.Msg.MQTT_PORT).appendField(new Blockly.FieldTextInput("1883"), "PORT");
            this.appendDummyInput().appendField(Blockly.Msg.MQTT_CLIENTID).appendField(new Blockly.FieldTextInput("AB_"), "CLIENTID");
            this.appendDummyInput().appendField(Blockly.Msg.MQTT_USER).appendField(new Blockly.FieldTextInput(""), "USER");
            this.appendDummyInput().appendField(Blockly.Msg.MQTT_PASS).appendField(new Blockly.FieldTextInput(""), "PASS");
            this.setInputsInline(!1);
            this.setPreviousStatement(!0,
                null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.mqtt_pub = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.mqtt.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/mqtt.svg", 40, 25)).appendField(Blockly.Msg.MQTT_PUB);
            this.appendValueInput("TOPIC", "String").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.MQTT_TOPIC);
            this.appendValueInput("MSG", "String").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.MQTT_VALUE);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.mqtt_sub = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.mqtt.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/mqtt.svg", 40, 25)).appendField(Blockly.Msg.MQTT_SUB);
            this.appendValueInput("TOPIC", "String").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.MQTT_TOPIC);
            this.appendDummyInput("").setAlign(Blockly.ALIGN_RIGHT).appendField("> ").appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME), "VAR");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null);
        },
        getVars: function() {
            return [this.getFieldValue("VAR")]
        }
    };
    /*
    // oJo Requiere .FieldVariableText()
    */
    Blockly.Blocks.mqtt_sub_text = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.mqtt.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/mqtt.svg", 40, 25)).appendField(Blockly.Msg.MQTT_SUB);
            this.appendValueInput("TOPIC", "String").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.MQTT_TOPIC);
            this.appendDummyInput("")
                .setAlign(Blockly.ALIGN_RIGHT).appendField("> ")
//                .appendField(new Blockly.FieldVariableText(Blockly.Msg.VARIABLES_DEFAULT_NAME_TEXT), "VARTEXT");
                .appendField(new Blockly.FieldVariable(Blockly.Msg.VARIABLES_DEFAULT_NAME_TEXT, null, ['String'], 'String'), "VARTEXT")
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null);
        },
        getVarsText: function() {
            return [this.getFieldValue("VARTEXT")]
        },
        renameVarText: function(a, b) {
            Blockly.Names.equals(a, this.getFieldValue("VARTEXT")) && this.setFieldValue(b, "VARTEXT")
        }
    };
    Blockly.Blocks.mqtt_isconnected = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.mqtt.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/mqtt.svg", 40, 25)).appendField(Blockly.Msg.MQTT_ISCONNECTED);
            this.setOutput(!0, "Boolean");
        }
    };
    Blockly.Blocks.mqtt_thingspeak_pub = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.mqtt.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/mqtt_thingspeak_pub.svg", 120, 50));
            this.appendDummyInput().appendField("Channel ID").appendField(new Blockly.FieldTextInput(""), "CHANNEL");
            this.appendDummyInput().appendField("Write API Key").appendField(new Blockly.FieldTextInput(""), "APIKEY");
            this.appendDummyInput().appendField("Field").appendField(new Blockly.FieldDropdown([
                ["field1", "field1"],
                ["field2", "field2"],
                ["field3", "field3"],
                ["field4", "field4"],
                ["field5", "field5"],
                ["field6", "field6"],
                ["field7", "field7"],
                ["field8", "field8"]
            ]), "FIELD");
            this.setInputsInline(!1);
            this.setOutput(!0, "String")
        }
    };
    Blockly.Blocks.mqtt_thingspeak_sub = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.mqtt.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/mqtt_thingspeak_sub.svg", 111, 26));
            this.appendDummyInput().appendField("Channel ID").appendField(new Blockly.FieldTextInput(""), "CHANNEL");
            this.appendDummyInput().appendField("Read API Key").appendField(new Blockly.FieldTextInput(""), "APIKEY");
            this.appendDummyInput().appendField("Field").appendField(new Blockly.FieldDropdown([
                ["field1",
                    "field1"
                ],
                ["field2", "field2"],
                ["field3", "field3"],
                ["field4", "field4"],
                ["field5", "field5"],
                ["field6", "field6"],
                ["field7", "field7"],
                ["field8", "field8"]
            ]), "FIELD");
            this.setInputsInline(!1);
            this.setOutput(!0, "String")
        }
    };
    Blockly.Blocks.mqtt_adafruit_pub = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.mqtt.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/mqtt_adafruit_pub.svg", 109, 26));
            this.appendDummyInput().appendField("User").appendField(new Blockly.FieldTextInput(""), "USER");
            this.appendDummyInput().appendField("Feed Key").appendField(new Blockly.FieldTextInput(""), "FEED");
            this.setInputsInline(!1);
            this.setOutput(!0,
                "String")
        }
    };
    Blockly.Blocks.mqtt_adafruit_sub = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.mqtt.style);
            this.appendDummyInput("").appendField(new Blockly.FieldImage(img_path + "arduino/mqtt_adafruit_sub.svg", 109, 26));
            this.appendDummyInput().appendField("User").appendField(new Blockly.FieldTextInput(""), "USER");
            this.appendDummyInput().appendField("Feed Key").appendField(new Blockly.FieldTextInput(""), "FEED");
            this.setInputsInline(!1);
            this.setOutput(!0,
                "String")
        }
    };
}
